import Vue from 'vue'
import datasource from './datasource'
import moment from 'moment'

Vue.use(require('vue-moment'))

moment.locale('de')

const timestamp = function () {
  return moment().format('LTS|')
}

const updateObject = function (obj, lst) {
  if (typeof lst.forEach === 'undefined') {
    console.log(` ${lst} is empty, no updates`)
    return
  }
  let seen = Object.keys(obj)
  console.log(`updating ${seen.length} objects with ${lst.length} objects`)
  const started = seen.length
  lst.forEach(function (item) {
    if (seen.indexOf(item.urn) > -1) {
      seen = seen.filter(function (a) { return a !== item.urn })
      item.firstseen = obj[item.urn].firstseen
      item.parsed_created = Date.parse(item.version_created)
    } else {
      item.parsed_created = Date.parse(item.version_created)
      item.firstseen = new Date()
      console.log(timestamp() + 'Added: "' + item.headline + '" ' + item.version_created)
    }
    Vue.set(obj, item.urn, item)
  })
  seen.forEach(function (item) {
    console.log(timestamp() + 'removed: "' + obj[item].headline + '"')
    Vue.delete(obj, item)
  })
  const ended = Object.keys(obj).length
  if (started !== ended) {
    console.log('started with ' + started + ', ended with ' + ended + ' items.')
  }
}

const getData = function (config) {
  datasource.slides(config).then(function (items) {
    let complete = []
    items.forEach(function (list) {
      complete.push(...list)
    })
    updateObject(window.data.slides, complete)
  })
  datasource.ticker(config).then(function (items) {
    if (items.length === 0) {
      items = [{ 'headline': 'error - no headlines', 'urn': 'no-headline' }]
    }
    items.forEach(function (list) {
      updateObject(window.data.ticker, list)
    })
  })
}

const checkVersion = function () {
  datasource.versionInfo().then(function (data) {
    const isAppCurrent = (document.location.search.substr(1) === data.git_describe)
    if (!isAppCurrent) {
      console.log('updating from ' + document.location.search.substr(1) + ' to ' + data.git_describe)
      document.location.search = data.git_describe
    }
    console.log(timestamp() + 'version unchanged: ' + JSON.stringify(data))
    window.data.version.git_describe = data.git_describe
    window.data.version.timestamp = data.timestamp
    window.data.version.url = document.location.href
  })
}

const updateStyle = function (css) {
  const root = document.documentElement.style
  root.setProperty('--brand-color', css.brand_color)
  root.setProperty('--logo-landscape', css.logo.landscape)
  root.setProperty('--logo-portrait', css.logo.portrait)
}

const setClasses = function (obj) {
  /*
   *
     setClasses({ source: slideDom,
                  destination: bodyDom,
                  search: '-slide',
                  replace: '-body' })

     copies classes from source to destination dom element
     replacing suffixes

     "wetter-slide" in a slide becomes "wetter-body" in the body
   *
   *
   */
  const sourceClasses = obj.source.classList
  const destClasses = obj.destination.classList
  const matchSrc = RegExp(obj.search + '$')
  const matchDes = RegExp(obj.destination + '$')
  let classList = []
  sourceClasses.forEach(function (item) {
    if (matchSrc.test(item)) {
      let newClass = item.replace(matchSrc, obj.replace)
      classList.push(newClass)
      obj.destination.classList.add(newClass)
    }
  })
  destClasses.forEach(function (item) {
    if (matchDes.test(item) && (classList.indexOf(item) === -1)) {
      obj.destination.classList.remove(item)
    }
  })
}

/*
 * message is 'down' or 'up' for mousebutton / touchscreen tap
 * storage is an array used for event storage
 * returns true if the code is equal to config.solution
 */
const morseReceiver = {
  state: [ Date.now() ],
  stateCSS: function () {
    const last = this.state[this.state.length - 2]
    if (last === '.') {
      return 'dot'
    } else if (last === '-') {
      return 'dash'
    }
  },
  process: function (message, solution) {
    const now = Date.now()
    let tapped = this.state
    const lastItem = tapped.length - 1
    const last = tapped[lastItem]
    const delay = now - last
    let tapcode = ''
    let stateClass = ''
    if (message === 'down') {
      if (delay > 10000) {
        console.log('tapcode reset')
        this.state = [ now ]
      } else {
        tapped[lastItem] = now
      }
    } else {
      if (delay < 200) {
        tapped[lastItem] = '.'
        stateClass = 'dot'
      } else {
        tapped[lastItem] = '-'
        stateClass = 'dash'
      }
      tapped.push(now)
      if (tapped.length > solution.length) {
        tapcode = tapped.slice(tapped.length - (solution.length + 1), tapped.length - 1).join('')
      } else {
        tapcode = tapped.slice(0, tapped.length - 1).join('')
      }
      console.log('tapcode ' + tapcode)
    }
    if (tapcode === solution) {
      this.state = [ now ]
      return 'OK'
    }
    return stateClass
  }
}

export default {
  updateObject: updateObject,
  getData: getData,
  checkVersion: checkVersion,
  updateStyle: updateStyle,
  setClasses: setClasses,
  morseReceiver: morseReceiver
}
